<template>
    <div @click="smoothScroll" data-scroll-offset="0" class="scroll-top" :class="{'visible': visible}">
        <div class="circle"></div>
        <div style="visibility: hidden;" class="text">{{$t('go_up')}}</div>
    </div>
</template>

<script>
import store from '../store/store'
import smoothScroll from '../helpers/SmoothScroll';

export default {
    name: 'scrollTop',
    computed: {
        visible: () => store.state.isScrollTopVisible,
        smoothScroll: () => smoothScroll
        
    }
}

</script>


// WEBPACK FOOTER //
// ScrollTop.vue?1093b9a0